module.exports = __webpack_public_path__ + "static/media/producer-cam-icon.bff449a5.svg";